type OverlayEnabledResult = overwolf.settings.games.OverlayEnabledResult;

// -----------------------------------------------------------------------------
export class OWSettingsGames {
  // ---------------------------------------------------------------------------
  public static getOverlayEnabled(gameId: number): Promise<boolean> {
    return new Promise((resolve) => {
      overwolf.settings.games.getOverlayEnabled(gameId, (result) => {
        const overlayEnabled = result.success && result.enabled;
        resolve(overlayEnabled);
      });
    });
  }
}
